<div class="container">
  <div class="search" style="padding-top: 20px">
    <span class="form">
      <mat-form-field class="size">
        <mat-label>Start Dates</mat-label>
        <input
          [(ngModel)]="sd"
          matInput
          [matDatepicker]="dob"
          (dateChange)="startDateChange($event)"
        />
        <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
        <mat-datepicker #dob></mat-datepicker>
      </mat-form-field>
    </span>
    <span class="form">
      <mat-form-field class="size">
        <mat-label>End Date</mat-label>
        <input
          [(ngModel)]="ed"
          matInput
          [matDatepicker]="end"
          (dateChange)="endDateChange($event)"
        />
        <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
        <mat-datepicker #end></mat-datepicker>
      </mat-form-field>
    </span>
    <!-- <span class="input" style="position: relative">
      <mat-form-field>
        <mat-label>Filter Mode</mat-label>
        <mat-select [(ngModel)]="filter" matNativeControl>
          <mat-option value="bills">Patient Bill</mat-option>
          <mat-option value="services">Services</mat-option>
        </mat-select>
      </mat-form-field>
    </span> -->
    <span class="input">
      <mat-form-field class="size">
        <mat-label>Name</mat-label>
        <input [(ngModel)]="name" matInput placeholder="" />
      </mat-form-field>
    </span>
    <span class="input">
      <mat-form-field class="size">
        <mat-label>Mobile No.</mat-label>
        <input type="number" [(ngModel)]="phone" matInput placeholder="" />
      </mat-form-field>
    </span>
    <span class="input" style="position: relative">
      <mat-form-field>
        <mat-label>Gender</mat-label>
        <mat-select [(ngModel)]="gender" matNativeControl>
          <mat-option value="Male">Male</mat-option>
          <mat-option value="Female">Female</mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Department</mat-label>
        <mat-select
          [(ngModel)]="dept_code"
          (selectionChange)="dept($event)"
          matNativeControl
        >
          <mat-option *ngFor="let dept of depts" [value]="dept.id">
            {{ dept.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Sub Department</mat-label>
        <mat-select
          [(ngModel)]="sub_dept_code"
          (selectionChange)="sub($event)"
          matNativeControl
        >
          <mat-option value="0">None </mat-option>
          <mat-option *ngFor="let dept of subDepts" [value]="dept.id">
            {{ dept.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" *ngIf="filter == 'services'">
      <mat-form-field class="size">
        <mat-label>Service Name</mat-label>
        <input
          type="text"
          [(ngModel)]="investigation"
          matInput
          placeholder=""
        />
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Collected</mat-label>
        <mat-select
          [(ngModel)]="is_collected"
          (selectionChange)="collected($event)"
          matNativeControl
        >
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Acknowledged</mat-label>
        <mat-select
          [(ngModel)]="is_acknowledged"
          (selectionChange)="acknowledged($event)"
          matNativeControl
        >
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Verified</mat-label>
        <mat-select
          [(ngModel)]="is_verified"
          (selectionChange)="verify($event)"
          matNativeControl
        >
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Finalized</mat-label>
        <mat-select
          [(ngModel)]="is_finalized"
          (selectionChange)="finalized($event)"
          matNativeControl
        >
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Printed</mat-label>
        <mat-select [(ngModel)]="is_printed" matNativeControl>
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Online</mat-label>
        <mat-select [(ngModel)]="is_online" matNativeControl>
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Dispatched</mat-label>
        <mat-select [(ngModel)]="is_dispatched" matNativeControl>
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Final</mat-label>
        <mat-select [(ngModel)]="is_final" matNativeControl>
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input">
      <button
        (click)="searchEcounters()"
        style="margin-bottom: 30px; margin-left: 0px"
        mat-raised-button
        color="primary"
      >
        Search
      </button>
      <button
        *ngIf="page == '/acknowledge-sample'"
        (click)="scan()"
        style="margin-bottom: 30px; margin-left: 0px"
        mat-raised-button
        color="primary"
      >
        Barcode
      </button>
    </span>
  </div>
  <div class="bills all" *ngIf="filter != 'services'">
    <div class="tests">
      <table style="width: 100%" *ngIf="!isLoading">
        <tr class="back">
          <th>Patient Name</th>
          <th>Bill Date</th>
          <th>Reg No.</th>
          <th>Total Amount</th>
          <th>Paid</th>
          <th></th>
        </tr>
        <tr class="td" *ngFor="let item of encounters" style="cursor: pointer">
          <td (click)="stat(item)">
            <p class="spnemergency" *ngIf="item.patient_type == 'EMR'">
              ***Emergency***
            </p>
            {{ item.patientName }}
          </td>
          <td (click)="getSamples(item.Bill_ID)">
            <span
              *ngIf="isWithinLastWeek(item.billDate)"
              style="
                color: white;
                background-color: blue;
                border-radius: 7px;
                padding: 1px 5px;
              "
            >
              New </span
            ><br />
            <div>{{ item.billDate | date }}</div>
            <div style="color: red">
              {{ item.billDate | date : "mediumTime" }}
            </div>
          </td>
          <td>{{ item.registration_no }}</td>
          <td>
            {{ item.totalAmount | currency : "&#8358;" }}
          </td>
          <td>{{ item.Recd_Payment }}</td>
          <td>
            <div class="dropdown">
              <button class="dropbtn" mat-raised-button>Actions</button>
              <div class="dropdown-content">
                <a class="dropdown-item" (click)="stat(item)">Stats</a>
                <!-- <a class="dropdown-item" (click)="getSamples(item)">View</a> -->
                <a class="dropdown-item" (click)="editBill(item.id)">Edit</a>
                <a
                  class="dropdown-item"
                  *ngIf="item.Recd_Payment != 'Yes'"
                  (click)="editBill(item.id)"
                  >Edit Bill</a
                >
              </div>
            </div>
          </td>
        </tr>
      </table>
      <div *ngIf="isLoading" style="margin-top: 200px" class="spinner">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  </div>
  <div class="stat" *ngIf="vissible" [@slideInOut]>
    <div class="name">{{ patientName }}</div>
    <table border="0">
      <tr style="color: white">
        <td>Samples</td>
        <td>{{ statResult?.total_samples }}</td>
      </tr>
      <tr [style.background]="collect" style="color: white">
        <td>Samples Collected</td>
        <td>{{ statResult?.samples_collected }}</td>
      </tr>
      <tr [style.background]="acknowledge" style="color: white">
        <td>Samples Acknowleged</td>
        <td>{{ statResult?.samples_acknowledged }}</td>
      </tr>
      <tr [style.background]="type" style="color: white">
        <td>Results Typed</td>
        <td>{{ statResult?.total_results }}</td>
      </tr>

      <tr [style.background]="verified" style="color: white">
        <td>Results Verified</td>
        <td>{{ statResult?.samples_verified }}</td>
      </tr>
      <tr [style.background]="online" style="color: white">
        <td>Results Pushed Online</td>
        <td>{{ statResult?.pushed_online }}</td>
      </tr>
      <tr [style.background]="finalize" style="color: white">
        <td>Results Finalized</td>
        <td>{{ statResult?.results_finalized }}</td>
      </tr>
      <tr [style.background]="printed" style="color: white">
        <td>Results Printed</td>
        <td>{{ statResult?.printed }}</td>
      </tr>
      <tr [style.background]="reception" style="color: white">
        <td>Results Dispatched(reception)</td>
        <td>{{ statResult?.result_dispatched_to_reception }}</td>
      </tr>
      <tr [style.background]="patient" style="color: white">
        <td>Results Dispatched(patient)</td>
        <td>{{ statResult?.result_dispactched_to_patient }}</td>
      </tr>
    </table>
  </div>

  <div class="services all" *ngIf="filter == 'services'">
    <div class="tests">
      <div class="color-code">
        <div class="color-title">
          Collected:
          <div style="background-color: #add8e6"></div>
        </div>
        <div class="color-title">
          Acknowledged:
          <div style="background-color: #ffb6c1"></div>
        </div>
        <div class="color-title">
          Typed:
          <div style="background-color: #e6e6fa"></div>
        </div>
        <div class="color-title">
          Verified:
          <div style="background-color: #fed8b1"></div>
        </div>
        <div class="color-title">
          Finalized:
          <div style="background-color: limegreen"></div>
        </div>
        <div class="color-title">
          Printed:
          <div style="background-color: green"></div>
        </div>
      </div>
      <table style="width: 100%" *ngIf="!isLoading">
        <tr class="back">
          <th style="width: 6%">Lab ID</th>
          <th style="width: 8%">Test ID</th>
          <th style="width: 25%">Patient</th>
          <th style="width: 10%">Bill Date</th>
          <th style="width: 20%">Service</th>
          <th>Status</th>
        </tr>
        <tr
          class="td"
          *ngFor="let item of services"
          [ngClass]="getRowClass(item)"
          style="cursor: pointer"
        >
          <td>{{ item.Bill_ID }}</td>
          <td>{{ item.sample_id }}</td>
          <td>
            <p class="spnemergency" *ngIf="item.patient_type == 'EMR'">
              ***Emergency***
            </p>
            <p class="statspn">{{ item.registration_no }}</p>
            <p class="statspn">{{ item.patientName }}</p>
            <p class="statspn">
              {{ item.patient_phone }} - {{ item.patient_gender }}
            </p>
          </td>
          <td (click)="getSamples(item.Bill_ID)">
            <span
              *ngIf="isWithinLastWeek(item.billDate)"
              style="
                color: white;
                background-color: blue;
                border-radius: 7px;
                padding: 1px 5px;
              "
            >
              New </span
            ><br />
            <span>{{ item.billDate | date }}</span>
            <div>
              {{ item.billDate | date : "mediumTime" }}
            </div>
            <!-- <div style="color: red">
                {{ item.billDate | date : "mediumTime" }}
              </div> -->
          </td>
          <td (click)="getSamples(item.Bill_ID)">
            {{ item.service.service_name }}
          </td>
          <td (click)="getSamples(item.Bill_ID)">
            <p class="statspn" *ngIf="item.service.collected == 'Y'">
              {{
                item.service.collected_timestamp | date : "yyyy-MM-dd HH:mm a"
              }}
              - Sample Collected
            </p>
            <p class="statspn" *ngIf="item.service.acknowledged == 'Y'">
              {{
                item.service.acknowledged_timestamp
                  | date : "yyyy-MM-dd HH:mm a"
              }}
              - Sample Acknowledged
            </p>
            <p class="statspn" *ngIf="item.service.prepared == 'Y'">
              {{
                item.service.prepared_timestamp | date : "yyyy-MM-dd HH:mm a"
              }}
              - Result Typed
            </p>
            <p class="statspn" *ngIf="item.service.verified == 'Y'">
              {{
                item.service.verified_timestamp | date : "yyyy-MM-dd HH:mm a"
              }}
              - Result Verfied
            </p>
            <p
              class="statspn"
              *ngIf="
                item.service.prepared == 'N' && item.service.acknowledged == 'Y'
              "
            >
              Pending Result Finalization
            </p>
            <p class="statspn" *ngIf="item.service.finalized_timestamp">
              {{
                item.service.finalized_timestamp | date : "yyyy-MM-dd HH:mm a"
              }}
              - Result Finalized
            </p>

            <p class="statspn" *ngIf="item.service.online == 'Y'">
              {{ item.service.online_timestamp | date : "yyyy-MM-dd HH:mm a" }}
              - Result Online
            </p>

            <p class="statspn" *ngIf="item.service.printed == 'Y'">
              {{ item.service.printed_timestamp | date : "yyyy-MM-dd HH:mm a" }}
              - Result Printed
            </p>
            <p class="statspn" *ngIf="item.service.dispatched == 'Y'">
              {{
                item.service.acknowledged_timestamp
                  | date : "yyyy-MM-dd HH:mm a"
              }}
              - Result Dispatched
            </p>
          </td>
        </tr>
      </table>
      <div *ngIf="isLoading" style="margin-top: 200px" class="spinner">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  </div>
</div>
